import request from '@/utils/request';
import { endpoints } from '@/constants/urls';
import { removeUUIDsFromCohortClauses } from '../clauses/state/state';

const selectionCounts = (clauses) => {
  const data = {
    queries: [
      {
        name: 'Cohort counts query',
        clauses: removeUUIDsFromCohortClauses(clauses, true),
      },
    ],
  };

  return request({
    url: endpoints.SELECTION_COHORT_COUNTS,
    data,
    method: 'POST',
  });
};

const cohortCounts = (cohortCode, data) => request({
  url: `/cohorts/${cohortCode}/cohort-counts`,
  data,
  method: 'POST',
});

const queryCounts = ({ cohortCode, queryId, dictionaryCode }) => cohortCounts(cohortCode, {
  query_id: queryId,
  dictionary_code: dictionaryCode,
});

const clauseCounts = ({ cohortCode, clauseId }) => cohortCounts(cohortCode, {
  clause_id: clauseId,
});

const CohortProfileService = {
  selectionCounts,
  queryCounts,
  clauseCounts,
};

export default CohortProfileService;
